import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { UserAvailableSlotOutput } from '../model/user-available-slot.output';

export interface FetchCoachAvailableSlotsInput {
	readonly coachId: string;
	readonly endDateTime: number;
	readonly startDateTime: number;
}

export interface FetchCoachAvailableSlotsParams {
	query: FetchCoachAvailableSlotsInput;
}

@Injectable({ providedIn: 'root' })
export class FetchCoachAvailableSlotsApiQuery extends ApiQuery<
	UserAvailableSlotOutput[],
	FetchCoachAvailableSlotsParams
> {
	client = 'iam';
	document = gql`
		query FetchCoachAvailableSlots($query: FetchCoachAvailableSlotsInput!) {
			fetchCoachAvailableSlots(input: $query) {
				startDate
				endDate
			}
		}
	`;
	method = 'fetchCoachAvailableSlots';
}
